import * as React from 'react';

import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ICalendarState, CalendarActions, IEventMonth } from '@adage/ace-calendar';
import axios from 'axios';
import { IOption } from '../../classes/index'
import Dropdown from '../../views/controlled-dropdown';
import { IArenaEvent } from '../classes/event';
import * as moment from 'moment';
import { JumpToFirstEventMonth } from '../calendar-helpers'

interface DropdownComponentState {
    options: Array<IOption>;
    selectedItem: string;
    events: any;
}

interface ClearingProps {
    shouldClear: boolean;
    isMobile: boolean;
    numberOfMonth: number;
}

class DropdownComponent extends React.Component<ClearingProps, DropdownComponentState> {

    constructor(props) {
        super(props);

        this.state = {
            options: [],
            selectedItem: " ",
            events: []
        };
    }

    componentWillMount() {
        axios.get(`/api/Calendar/GetProductionsFilters`).then(response => {
            const optionValues: Array<IOption> = response.data.map(item => { return { text: item.text, value: item.value } });
            optionValues.unshift({ text: `All`, value: '' });

            this.setState({
                options: optionValues
            });
        }).catch(err => {
            console.log(err);
        });
    }

    componentWillReceiveProps(props: ClearingProps) {
        if (props.shouldClear != this.props.shouldClear) {
            this.setState({
                selectedItem: ""
            })
        }
    }

    private filter(event: IArenaEvent) {
        return this.state.selectedItem.length == 0 ? true : event.name == this.state.selectedItem
    }

    private filterBind = this.filter.bind(this)

    onChange(evt: React.ChangeEvent<HTMLSelectElement>) {
        this.setState({
            selectedItem: evt.currentTarget.value
        })
        CalendarActions.updateEventFilter({
            key: "productionFilter",
            filter: this.filterBind
        })

        JumpToFirstEventMonth.bind(this)(this.props.isMobile);
    }

    render() {
        return <Dropdown hideLabel={false} selectedValue={this.state.selectedItem} options={this.state.options} label="Production" htmlId="production-dropdown-js" onChange={this.onChange.bind(this)} />
    }
}



export default (DropdownComponent);


// WEBPACK FOOTER //
// ./app/calendar/components/production-selection.tsx